import PageLayout from 'pages/CreateFormative/PageLayout';
import PageProvider from 'pages/CreateFormative/PageProvider';

const CreateFormativePage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default CreateFormativePage;
